export default __webpack_public_path__ + "static/favicon-7114e4fd1707addc80e48af17399dd72.png";